import { render, staticRenderFns } from "./ViewAssessment.vue?vue&type=template&id=7a11a4ee&"
import script from "./ViewAssessment.vue?vue&type=script&lang=js&"
export * from "./ViewAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssessment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports